export enum BalanceType {
    Original = "Original",
    Paid = "Paid",
    Balance = "Balance",
}